// import { configureStore } from "@reduxjs/toolkit";
// import commonSlices from "./common/commonSlices";

// // role based store
// import adminSlices from "./admin/adminSlices";


// const generateRoleBasedStore = (user) => {
//   const roleBasedSlices = {
//     common: { ...commonSlices },
//     admin: { ...commonSlices, ...adminSlices },
//   };

//   let store = configureStore({
//     reducer: roleBasedSlices[user?.role || "common"]
//   });
//   return store;
// }

// export default generateRoleBasedStore;
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import loaderSlice from "./common/loader/loaderSlice";
import alertSlice from "./common/alert/alertSlice";
import authSlice from "./common/auth/authSlice";

const staticReducers = {
    auth: authSlice,
    loader: loaderSlice,
    alert: alertSlice,
};

let asyncReducers = {};

const createReducer = () => combineReducers({
    ...staticReducers,
    ...asyncReducers,
});

const store = configureStore({
    reducer: createReducer()
});

export const injectReducer = (key, asyncReducer) => {
    if (!asyncReducers[key]) {
        asyncReducers[key] = asyncReducer;
        store.replaceReducer(createReducer());
    }
};

export default store;